import { render, staticRenderFns } from "./loginDev.vue?vue&type=template&id=15b16c61&"
import script from "./loginDev.vue?vue&type=script&lang=ts&"
export * from "./loginDev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports